import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { ritualSteps } from '../../data/ritual';
import type { Product } from '../../types/product';
export function ProductDetails({
  product
}: {
  product: Product;
}) {
  const [open, setOpen] = useState<number>(0);
  const living = product.line === 'living';
  const sections = [{
    title: 'Beschrijving',
    body: product.what
  }, {
    title: living ? 'Materiaal & afmetingen' : 'Werking',
    body: product.does
  }, {
    title: living ? 'Onderhoud' : 'Zo gebruik je het',
    body: product.use
  }];
  const step = product.ritualStep ? ritualSteps[product.ritualStep - 1] : undefined;
  return <section id="details" className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-12 lg:px-8 lg:py-24" data-id="element-456" data-mp="smyphskc9osa">
      <div className="lg:col-span-7" data-id="element-457" data-mp="dr97e5i9xvsu">
        <h2 className={living ? 'text-3xl font-semibold tracking-tight sm:text-4xl' : 'font-display text-3xl uppercase tracking-display sm:text-4xl'} data-id="element-458" data-mp="ioskh238k2j7">
          Productinformatie
        </h2>
        <ul className="mt-8 border-b border-line" data-id="element-459" data-mp="2xz2jettjk37s">
          {sections.map((s, i) => {
          const isOpen = open === i;
          return <li key={s.title} className="border-t border-line" data-id="element-460" data-mp="3by211himzhug" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between py-5 text-left text-lg font-semibold" data-id="element-461" data-mp="37wqi1uu9puv8">
                  {s.title}
                  <PlusIcon className={`h-5 w-5 transition-transform duration-200 ${isOpen ? 'rotate-45 text-pink' : ''}`} aria-hidden="true" data-id="element-462" data-mp="2t0r8sgvf9ooi" />
                </button>
                <AnimatePresence initial={false} data-id="element-463" data-mp="20j6ihkgvcw8m">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-464" data-mp="1whtfrj92p95x">
                      <p className="max-w-2xl pb-6 text-lg leading-relaxed text-muted" data-id="element-465" data-mp="97ihn4y8vssr">{s.body}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>

      {step && product.ritualStep && <aside className="self-start rounded-3xl bg-surface p-8 lg:col-span-4 lg:col-start-9" data-id="element-466" data-mp="3hnlfkizk233w">
          <p className="text-sm font-medium text-pink" data-id="element-467" data-mp="3ml3qug11ouf2">Stap {product.ritualStep} van 9</p>
          <p className="mt-2 font-display text-2xl uppercase tracking-display" data-id="element-468" data-mp="3rm15iimuj6bt">{step.title}</p>
          <p className="mt-2 text-muted" data-id="element-469" data-mp="11umg0r2u18vk">{step.text}</p>
          <div className="mt-6 flex gap-1" aria-hidden="true" data-id="element-470" data-mp="11y0gtuvula0w">
            {ritualSteps.map((_, i) => <span key={i} className={`h-1 flex-1 rounded-full ${i < product.ritualStep! ? 'bg-pink' : 'bg-line'}`} data-id="element-471" data-mp="2rctdpcuni8r2" data-mpi={i} />)}
          </div>
          <Link to="/over-amira" className="mt-6 inline-block text-sm font-medium underline underline-offset-4" data-id="element-472" data-mp="2mf1avnsgx283">
            Bekijk alle 9 stappen
          </Link>
        </aside>}
    </section>;
}